// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (max-width: 768px) {\n  .navigation a {\n    font-size: 0.7rem;\n    padding: 4px 6px;\n  }\n}", "",{"version":3,"sources":["webpack://./src/components/Nav.scss"],"names":[],"mappings":"AAAA;EACE;IACE,iBAAA;IACA,gBAAA;EACF;AACF","sourcesContent":["@media (max-width: 768px) {\n  .navigation a {\n    font-size: 0.7rem;  \n    padding: 4px 6px; \n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
